import { Dialog } from 'primereact/dialog';
import { Divider } from 'primereact/divider';

import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { InputTextarea } from 'primereact/inputtextarea';
import classes from '../marketStrategyEditModal/marketStrategyEditModal.module.scss';
import useMarketStrategyAddModal from './useMarketStrategyAddModal';

const MarketStrategyAddModal = ({
  visibility,
  toggleVisibility,
  handleNewStrategySelect,
}: {
  visibility: boolean;
  toggleVisibility: () => void;
  handleNewStrategySelect: (option: { code: string; name: string }) => void;
}) => {
  const { name, setName, description, setDescription, addMethods, isAddLoading, errors } =
    useMarketStrategyAddModal({ handleNewStrategySelect });

  return (
    <Dialog
      headerClassName={classes.modalHeader}
      header={'TMS Strategy'}
      visible={visibility}
      style={{ maxWidth: '35rem', width: '35rem' }}
      onHide={() => {
        if (!visibility) return;
        toggleVisibility();
      }}
      resizable={false}
      draggable={false}
    >
      <div className={classes.modalContainer} style={{ gap: '2rem' }}>
        <Divider className={classes.devider} />
        <div className={classes.inputTextDivWrapper} style={{ alignItems: 'center' }}>
          <label style={{ marginRight: '2rem' }} htmlFor="username">{`Name`}</label>
          <InputText
            style={{ flexGrow: 1 }}
            type="text"
            value={name}
            onChange={e => setName(e.target.value)}
            aria-describedby="username-help"
          />
        </div>
        <div className={classes.inputTextDivWrapper} style={{ alignItems: 'center' }}>
          <label htmlFor="username">{`Description`}</label>
          <InputTextarea
            style={{ flexGrow: 1, resize: 'none' }}
            value={description}
            onChange={e => setDescription(e.target.value)}
            aria-describedby="username-help"
          />
        </div>
        {errors && (
          <div className={classes.errorWrapper}>
            <span>*{errors}</span>
          </div>
        )}
        <div className={classes.buttonWrapper}>
          <Button className={classes.cancelButton} onClick={toggleVisibility}>
            Cancel
          </Button>
          <Button
            loading={isAddLoading}
            className={classes.addButton}
            onClick={addMethods.handleAddTMSStrategy}
          >
            Add
          </Button>
        </div>
      </div>
    </Dialog>
  );
};

export default MarketStrategyAddModal;
